import React, { useEffect } from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';
import Banner from '../../Banner';
import { Link, useLocation } from 'react-router-dom';

const GizlilikVeri: React.FC = () => {
  const location = useLocation();
  const language = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const lang: 'en' | 'tr' = language;

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    window.location.href = newPath;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumb = (
    <>
      <Link to={`/${lang}`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Sertifikasyon ve Dökümantasyon' : 'Certification & Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification/documents`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Dökümantasyon' : 'Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <span className="text-white font-bold">{lang === 'tr' ? 'Gizlilik Politikası ve Kişisel Veriler' : 'Privacy Policy & Personal Data'}</span>
    </>
  );

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={lang === 'tr' ? 'Gizlilik Politikası ve Kişisel Veriler' : 'Privacy Policy & Personal Data'}
        description={lang === 'tr' ? 'Kişisel verilerinizin gizliliği ve korunması esasları.' : 'Principles of privacy and protection of your personal data.'}
        breadcrumb={breadcrumb}
      />
      <div className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          {lang === 'tr' ? (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kişisel Verilerin İşlenmesi</h3>
                <p className="text-gray-700 leading-relaxed">CG Teknoloji, kişisel verilerinizi 6698 sayılı KVKK ve Avrupa Birliği Genel Veri Koruma Tüzüğü (GDPR) başta olmak üzere yürürlükteki tüm mevzuata uygun biçimde işlemektedir.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Hangi Veriler Toplanır?</h3>
                <p className="text-gray-700 leading-relaxed">Web sitemiz aracılığıyla ad-soyad, e-posta, telefon numarası, şirket bilgileri ve mesaj içeriği gibi veriler toplanabilir. Ayrıca IP adresi, tarayıcı bilgisi ve çerez verileri otomatik olarak kaydedilebilir.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Verilerin İşlenme Hukuki Dayanakları</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li>Açık rıza (KVKK Madde 5/1)</li>
                  <li>Sözleşmenin kurulması veya ifası (Madde 5/2-c)</li>
                  <li>Meşru menfaat (Madde 5/2-f)</li>
                  <li>Yasal yükümlülük (Madde 5/2-ç)</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Saklama Süreleri</h3>
                <p className="text-gray-700 leading-relaxed">Kişisel verileriniz, işlenme amacının ortadan kalkmasıyla birlikte veya yasal saklama süreleri dolduğunda silinir, yok edilir ya da anonim hale getirilir.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Veri Güvenliği</h3>
                <p className="text-gray-700 leading-relaxed">Şifreleme, erişim kontrolü ve güvenli altyapı gibi teknik önlemlerle verilerinizin güvenliği sağlanmaktadır. Tüm çalışanlar ve iş ortakları gizlilik yükümlülüğüne tabidir.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Veri Sorumlusu</h3>
                <p className="text-gray-700 leading-relaxed">Veri sorumlusu: <strong>CG Yapay Zeka Teknoloji Yatırımları A.Ş.</strong> | E-posta: info@cgteknoloji.com</p>
              </section>
            </div>
          ) : (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Processing of Personal Data</h3>
                <p className="text-gray-700 leading-relaxed">CG Teknoloji processes your personal data in accordance with all applicable legislation, primarily the Personal Data Protection Law No. 6698 (KVKK) and the European Union General Data Protection Regulation (GDPR).</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">What Data Is Collected?</h3>
                <p className="text-gray-700 leading-relaxed">Through our website, data such as name-surname, email, phone number, company information, and message content may be collected. Additionally, IP address, browser information, and cookie data may be automatically recorded.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Legal Bases for Data Processing</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li>Explicit consent (KVKK Article 5/1)</li>
                  <li>Establishment or performance of a contract (Article 5/2-c)</li>
                  <li>Legitimate interest (Article 5/2-f)</li>
                  <li>Legal obligation (Article 5/2-ç)</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Retention Periods</h3>
                <p className="text-gray-700 leading-relaxed">Your personal data is deleted, destroyed, or anonymized when the purpose of processing ceases or when legal retention periods expire.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Data Security</h3>
                <p className="text-gray-700 leading-relaxed">The security of your data is ensured through technical measures such as encryption, access control, and secure infrastructure. All employees and business partners are subject to confidentiality obligations.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Data Controller</h3>
                <p className="text-gray-700 leading-relaxed">Data Controller: <strong>CG Yapay Zeka Teknoloji Yatırımları A.Ş.</strong> | Email: info@cgteknoloji.com</p>
              </section>
            </div>
          )}
        </div>
      </div>
      <Footer language={lang} />
    </div>
  );
};

export default GizlilikVeri; 